import config from "./../config";
import BackendAPI from "./backendAPI";

export const backendAPI = new BackendAPI(config.BACKEND_API_BASE);
